import api, { setDefaultHeaders } from './api';

// Auth
export function signup({ name, email, password }) {
  return api.post('users', { name, email, password });
}

export function signin({ email, password }) {
  return api.post('auth', { email, password });
}

export function me() {
  return api.get('auth/me');
}

export function forgotPassword(email) {
  return api.post('auth/forgot-password', { email });
}

export function resetPassword(userId, token, newPassword) {
  setDefaultHeaders({ authorization: `Bearer ${token}` });

  return api.patch(`users/${userId}/update-password`, {
    password: newPassword,
  });
}

// Users
export function updateUserInfo(userId, info) {
  return api.patch(`users/${userId}`, info);
}

export function getAllUsers() {
  return api.get('users');
}

// Training Routines
export function createTrainingRoutine(newTrainingRoutine) {
  return api.post('training-routines', newTrainingRoutine);
}

export function updateTrainingRoutineInfo(trainingRoutineId, info) {
  return api.patch(`training-routines/${trainingRoutineId}`, info);
}

export async function getActiveTrainingRoutine() {
  return api.get('training-routines?active');
}

export function getTrainingRoutinesByUserId(userId) {
  return api.get(`users/${userId}/training-routines`);
}

export function getTrainingRoutineById(trainingRoutineId) {
  return api.get(`training-routines/${trainingRoutineId}`);
}

export function deleteTrainingRoutine(trainingRoutineId) {
  return api.delete(`training-routines/${trainingRoutineId}`);
}

// Workouts
export function createWorkout(newWorkout) {
  return api.post('workouts', newWorkout);
}

export function updateWorkoutInfo(workoutId, info) {
  return api.patch(`workouts/${workoutId}`, info);
}

export function getWorkoutsFromActiveTrainingRoutine() {
  return api.get('training-routines/workouts?finishDate=null');
}

export function getWorkoutsByTrainingRoutineId(trainingRoutineId) {
  return api.get(`training-routines/${trainingRoutineId}/workouts`);
}

export function getWorkoutById(workoutId) {
  return api.get(`workouts/${workoutId}`);
}

export function deleteWorkout(workoutId) {
  return api.delete(`workouts/${workoutId}`);
}

// Blocks
export function createBlock(newBlock) {
  return api.post('blocks', newBlock);
}

export function getBlocksByWorkoutId(workoutId) {
  return api.get(`workouts/${workoutId}/blocks`);
}

export function updateBlockInfo(blockId, info) {
  return api.patch(`blocks/${blockId}`, info);
}

export function deleteBlock(blockId) {
  return api.delete(`blocks/${blockId}`);
}

// Exercises
export function createExercise(newExercise) {
  return api.post('exercises', newExercise);
}

export function updateExerciseInfo(exerciseId, info) {
  return api.patch(`exercises/${exerciseId}`, info);
}

export function deleteExercise(exerciseId) {
  return api.delete(`exercises/${exerciseId}`);
}
